<script setup lang="ts">
import { type DialogController, sleep } from "@/vf"
import { computed, ref, type RenderFunction, type VNode } from "vue"

export interface ShopConfirmDialogOptions {
    title: string
    message: string | RenderFunction
    yesButton: (controller: DialogController<boolean, ShopConfirmDialogOptions>) => VNode
    noButton: (controller: DialogController<boolean, ShopConfirmDialogOptions>) => VNode
}

const props = defineProps<{
    controller: DialogController<boolean, ShopConfirmDialogOptions>
}>()
const options = computed(() => props.controller.props)
const closeButton = ref<HTMLButtonElement | null>(null)

sleep(100).then(() => closeButton.value?.focus())
</script>

<template>
    <div>
        <div class="dialog-header">
            <h2>{{ options.title }}</h2>
        </div>

        <div class="dialog-body">
            <p v-if="typeof options.message === 'string'">{{ options.message }}</p>
            <component :is="options.message" v-else></component>
        </div>

        <div class="dialog-footer">
            <component :is="options.noButton(controller)" ref="closeButton"></component>
            <component :is="options.yesButton(controller)"></component>
        </div>
    </div>
</template>
